import {
  $applyNodeReplacement,
  DecoratorNode,
  type LexicalNode,
  type NodeKey,
  type SerializedLexicalNode,
} from "lexical";
import type { ReactNode } from "react";
import { CustomEmoji } from "./custom-emoji";

type SerializedCustomEmojiNode = {
  type: "custom-emoji";
  version: 1;
  name: string;
} & SerializedLexicalNode;

export class CustomEmojiNode extends DecoratorNode<ReactNode> {
  __name: string;

  static getType(): string {
    return "custom-emoji";
  }

  static clone(node: CustomEmojiNode): CustomEmojiNode {
    return new CustomEmojiNode(node.__name, node.__key);
  }

  constructor(name: string, key?: NodeKey) {
    super(key);
    this.__name = name;
  }

  createDOM(): HTMLElement {
    const span = document.createElement("span");
    span.className = "custom-emoji";
    span.style.display = "inline-flex";
    span.style.alignItems = "center";
    span.style.justifyContent = "center";
    return span;
  }

  updateDOM(): boolean {
    return false;
  }

  decorate(): ReactNode {
    return <CustomEmoji name={this.__name} />;
  }

  static importJSON(serializedNode: SerializedCustomEmojiNode): CustomEmojiNode {
    const { name } = serializedNode;
    return $createCustomEmojiNode(name);
  }

  exportJSON(): SerializedCustomEmojiNode {
    return {
      type: "custom-emoji",
      version: 1,
      name: this.__name,
    };
  }

  isInline(): boolean {
    return true;
  }

  isIsolated(): boolean {
    return true;
  }

  getEmojiId(): string {
    const self = this.getLatest();
    return self.__name;
  }

  getTextContent(): string {
    const self = this.getLatest();
    return `:${self.__name}:`;
  }
}

export function $createCustomEmojiNode(name: string): CustomEmojiNode {
  return $applyNodeReplacement(new CustomEmojiNode(name));
}

export function $isCustomEmojiNode(node: LexicalNode | null | undefined): node is CustomEmojiNode {
  return node instanceof CustomEmojiNode;
}
